module.exports = __webpack_public_path__ + "img/caracteristicas-rad-conv-arco.3edb08d4.png";